import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import Loading from 'core/subapps/Loading'
import storage from 'util/storage'
import { selectCurrentMailboxId } from 'selectors/mailboxes'
import { selectShowContinueForwardingSetupPane } from 'selectors/layout'
import MailboxContinueForwardingSetup from 'components/App/DesktopView/Layout/MailboxContinueForwardingSetup'
import { selectIsChannelOnboardingDrawerOpen } from 'ducks/drawers/selectors'
import ClassicView from './ClassicView'
import ModernView from './ModernView'

const storageSearchKeysForMailboxAndTicket = [
  'lastSearchQueryId',
  'ticketListForLastViewedTicket',
  'latestMailboxContext',
  'ticketListFromFirstPinnedSearch',
]

export default function LayoutSwitcher(props) {
  const {
    isBootstrapped,
    prefersClassicView,
    realMailboxes,
    redirectToSearchPageWithMailboxAndFolder,
    isNewConversation,
    isNewEmail,
  } = props

  const mailboxId = useSelector(selectCurrentMailboxId)
  const showContinueForwardingSetupPane = useSelector(
    selectShowContinueForwardingSetupPane
  )
  const isChannelOnboardingDrawerOpen = useSelector(
    selectIsChannelOnboardingDrawerOpen
  )
  const isNewConvo = isNewConversation || isNewEmail

  useEffect(
    () => {
      const hasMailboxOrTicketSearch = storageSearchKeysForMailboxAndTicket.find(
        key => !!storage.get(key)
      )
      if (
        !isBootstrapped ||
        hasMailboxOrTicketSearch ||
        realMailboxes.length === 0 ||
        isChannelOnboardingDrawerOpen
      ) {
        return
      }
      const firstMailbox = realMailboxes[0]
      const firstMailboxId = firstMailbox?.id
      const firstFolderId = firstMailbox?.folders?.[0]
      redirectToSearchPageWithMailboxAndFolder(firstMailboxId, firstFolderId)
    },
    [
      realMailboxes,
      isBootstrapped,
      redirectToSearchPageWithMailboxAndFolder,
      isChannelOnboardingDrawerOpen,
    ]
  )

  useEffect(
    () => {
      if (prefersClassicView) {
        document.body.classList.toggle('classic-inbox-view', true)
        document.body.classList.toggle('modern-inbox-view', false)
      } else {
        document.body.classList.toggle('classic-inbox-view', false)
        document.body.classList.toggle('modern-inbox-view', true)
      }
    },
    [prefersClassicView]
  )

  if (!isBootstrapped) return <Loading />

  if (!isNewConvo) {
    if (showContinueForwardingSetupPane) {
      return <MailboxContinueForwardingSetup mailboxId={mailboxId} />
    }
  }

  if (prefersClassicView) {
    return <ClassicView {...props} />
  }

  return <ModernView {...props} />
}
